import { BadgeProgress } from '../client/users-api'

// Session cache for the owner's badge list plus the input "signature" the cached
// badges were computed from. Badges are computed server-side and the section
// remounts on every profile visit, so without this the endpoint refired on each
// navigation. We now refetch ONLY when the signature changes - i.e. when a badge
// input (watched episodes, movies, favorites) changed since the last fetch.
// Plain tab switches with no activity make zero calls. Mirrors media-state.cache.ts.
const cacheKey = 'my-badges-cache'
const signatureKey = 'my-badges-signature'

export const readBadgesCache = (): BadgeProgress[] | null => {
  const cached = sessionStorage.getItem(cacheKey)
  if (!cached) return null
  try {
    const parsed = JSON.parse(cached)
    return Array.isArray(parsed) ? (parsed as BadgeProgress[]) : null
  } catch {
    return null
  }
}

export const writeBadgesCache = (badges: BadgeProgress[] | null) => {
  if (!badges) {
    sessionStorage.removeItem(cacheKey)
    return
  }
  sessionStorage.setItem(cacheKey, JSON.stringify(badges))
}

export const readBadgesSignature = (): string | null =>
  sessionStorage.getItem(signatureKey)

export const writeBadgesSignature = (signature: string) => {
  sessionStorage.setItem(signatureKey, signature)
}

export const clearBadgesCache = () => {
  sessionStorage.removeItem(cacheKey)
  sessionStorage.removeItem(signatureKey)
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  readBadgesCache,
  writeBadgesCache,
  readBadgesSignature,
  writeBadgesSignature,
  clearBadgesCache,
}
